import axios from 'axios';
import API_ROOT from '../constants/api';
import { getHeaders } from '../services/ApiServices';

const ROUTE = '/admin/statistics-encouragement-messages';

export const apiGetStatisticsEncouragementMessages = (token) => axios
  .get(`${API_ROOT}${ROUTE}`, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiPostStatisticsEncouragementMessage = (token, data) => axios
  .post(`${API_ROOT}${ROUTE}`, data, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiPutStatisticsEncouragementMessage = (token, id, data) => axios
  .put(`${API_ROOT}${ROUTE}/${id}`, data, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);

export const apiDeleteStatisticsEncouragementMessage = (token, id) => axios
  .delete(`${API_ROOT}${ROUTE}/${id}`, {
    headers: getHeaders(token),
  })
  .then((response) => response.data);
